export const isDevelopment = () => {
  const hostname = window.location.hostname;
  return hostname === 'localhost' || 
         hostname.includes('lovable.dev') ||
         hostname.includes('lovableproject.com') ||
         hostname.includes('lovable.app') ||
         hostname.includes('127.0.0.1');
};

export const isProduction = () => !isDevelopment();
